import { type Vendor, VendorStatus } from './vendor.types'

export const getVendorStatus = (vendor: Vendor): VendorStatus => {
  if (vendor.status === VendorStatus.activated && vendor.verificationNote) {
    return VendorStatus.additional_documents
  } else if (
    vendor.status === VendorStatus.pendingVerification &&
    vendor.additionalDocuments?.documents.length
  ) {
    return VendorStatus.pending_documents
  }
  return vendor.status
}
